
import React, { useEffect, useState } from "react";
import { 
    Button, 
    Grid, 
    Typography, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions,
    Card,
    Container,
    DialogContentText,
    Divider,
    IconButton,
} from "@mui/material";
import { 
  FitnessCenter, 
  SportsEsports, 
  EventAvailable, 
  PlaylistAddCheck, 
  ImportExport, 
  Public, 
  Assignment, 
  Create, 
  SupervisorAccount, 
  Build, 
  Settings 
} from "@mui/icons-material";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import { useNavigate } from "react-router-dom";
import ReplyIcon from '@mui/icons-material/Reply';
import { useTranslation } from "react-i18next";

import { ReactComponent as PlanCenter } from "../image/plan_center.svg";
import { ReactComponent as PlanIndividual } from "../image/plan_individual.svg";
import { ReactComponent as Pros1 } from "../image/pros_1.svg";
import { ReactComponent as Pros2 } from "../image/pros_2.svg";
import { ReactComponent as Pros3 } from "../image/pros_3.svg";
import top from "../image/top1.png";
import { PlanCard } from "../components/PlanCard";
import { PlanType } from "../components/PlanType";
import { ReactFade } from "../components/ReactFade";
  
interface ContactUsDialogProps {
  onClose: () => void,
  isOpen: boolean,
}

// const ContactUsDialog = (props: ContactUsDialogProps) => {
//   const {t} = useTranslation();
//   return (
//     <Dialog onClose={props.onClose} aria-labelledby="simple-dialog-title" open={props.isOpen}>
//       <DialogTitle id="simple-dialog-title">{t("plans.contact_us_dialog_title")}</DialogTitle>
//       <DialogContent style={{ padding: 30 }}>
//         <Typography variant='subtitle1'>
//           {t("plans.contact_us_dialog_email")}<a href="mailto: info@medmindtechnology.hk">info@medmindtechnology.hk</a>
//         </Typography>
//         <Typography variant='subtitle1'>
//           {t("plans.contact_us_dialog_phone")}
//         </Typography>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={props.onClose} color="primary">
//           {t("butt.ensure")}
//         </Button>
//       </DialogActions>
//     </Dialog >
//   )
// }
  
export default function PlansPage(props: any) {

  const navigate = useNavigate();

  // const [contactUsDialogOpen, setContactUsDialogOpen] = useState<boolean>(false);

  const [individualFullVersionPanelOpen, setIndividualFullVersionPanelOpen] = useState<boolean>(false);

  const [centerFullVersionPanelOpen, setCenterFullVersionPanelOpen] = useState<boolean>(false);

  const [chosenPlanType, setChosenPlanType] = useState<"individual" | "center" | null>(null);

  const {t} = useTranslation();

  const units_1 = t("plans.units_1");

  // const data = [
  //   [<Grid container spacing={0}>
  //     <Grid item sm={4} style={{ justifyContent: "flex-end", display: "flex" }}>
  //       <StarIcon style={{ color: 'orange' }} />
  //     </Grid>
  //     <Grid item sm={8} style={{ justifyContent: "start", display: "flex", alignSelf: "center", color: '#4B7B7D' }}>
  //       {t("plans.six_ability_training")}
  //     </Grid>
  //   </Grid>, <><b>9</b><>{units_1}</></>, <><b>16</b><>{units_1}</></>, <><b>~50</b><>{units_1}</></>],
  //   [<Grid container spacing={0}>
  //     <Grid item sm={4} style={{ justifyContent: "flex-end", display: "flex" }}>
  //       <StarIcon style={{ color: 'orange' }} />
  //     </Grid>
  //     <Grid item sm={8} style={{ justifyContent: "start", display: "flex", alignSelf: "center", color: '#4B7B7D' }}>
  //       {t("plans.five_topics")}
  //     </Grid>
  //   </Grid>, <><b>3</b><>{units_1}</></>, <><b>5</b><>{units_1}</></>, <><b>5</b><>{units_1}</></>],
  //   [<Grid container spacing={0}>
  //     <Grid item sm={4} style={{ justifyContent: "flex-end", display: "flex" }}>
  //       <SwapVertIcon style={{ color: 'indigo' }} />
  //     </Grid>
  //     <Grid item sm={8} style={{ justifyContent: "start", display: "flex", alignSelf: "center", color: '#4B7B7D' }}>
  //       {t("plans.personalized_daily_mission")}
  //     </Grid>
  //   </Grid>, < CheckIcon style={{ color: 'green' }} />, < CheckIcon style={{ color: 'green' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [t("plans.personalized_training_setting"), < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [<Grid container spacing={0}>
  //     <Grid item sm={4} style={{ justifyContent: "flex-end", display: "flex" }}>
  //       <SwapVertIcon style={{ color: 'indigo' }} />
  //     </Grid>
  //     <Grid item sm={8} style={{ justifyContent: "start", display: "flex", alignSelf: "center", color: '#4B7B7D' }}>
  //       {t("plans.auto_difficulty")}
  //     </Grid>
  //   </Grid>, < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [t("plans.multi-player"), < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [t("plans.data_analysis_report"), < CloseIcon style={{ color: 'red' }} />, < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [t("plans.acc_management"), < CloseIcon style={{ color: 'red' }} />, < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />],
  //   [t("plans.reward_system"), < CloseIcon style={{ color: 'red' }} />, < CloseIcon style={{ color: 'red' }} />, < CheckIcon style={{ color: 'green' }} />],
  // ]

  useEffect(() => { 
    document.body.style.backgroundColor = '#d8eff6' 
    props.setTitle("notShow");
  }, []);

  // const onContactUsOpen = () => {
  //   setContactUsDialogOpen(true);
  // }

  // const onContactUsClose = () => {
  //   setContactUsDialogOpen(false);
  // }

  const renderTrialPrice = () => {
    return (
      <>
        <div style={{ display: "inline" }}>
          <span style={{ fontSize: 22 }}>
            {t("plans.trial_free")}
          </span>
        </div>

        <div style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
          {t("plans.indi_trial")}
        </div>
      </>
    )
  }

  const renderCenterTrialPrice = () => {
    return (
      <>
        <div style={{ display: "inline" }}>
          <span style={{ fontSize: 22 }}>
            {t("plans.trial_free")}
          </span>
        </div>

        <div style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
          {t("plans.center_trial")}
        </div>
      </>
    )
  }

  const renderCenterPrice = () => {
    return (
      <>
        <div style={{ display: "inline" }}>
          <span style={{ fontSize: 22 }}>
            {t("plans.center_price_1")}
          </span>
        </div>

        <div style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
          {/* {"9033 7986（譚小姐）"} */}
        </div>

        <div style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
          {t("plans.center_price_2")}
        </div>
      </>
    )
  }

  const renderIndividualPrice = () => {
    return (
      <>
        <div style={{ display: "inline" }}>
          <span style={{ fontSize: 16 }}>
            {t("plans.indi_price_1")}
          </span>
          <span style={{ fontSize: 22 }}>
            {t("plans.indi_price_2")}
          </span>
          <span style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
            {t("plans.indi_price_3")}
          </span>
        </div>

        <div style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
          {t("plans.indi_price_4")}
        </div>

        <div style={{ display: "inline" }}>
          <span style={{ fontSize: 16 }}>
            {t("plans.indi_price_1")}
          </span>
          <span style={{ fontSize: 22 }}>
            {t("plans.indi_price_5")}
          </span>
          <span style={{ color: "#888", fontSize: 16, fontWeight: "normal" }}>
            {t("plans.indi_price_6")}
          </span>
        </div>
      </>
    )
  };

  const renderIndividualPlanCards = () => (
    <Grid container style={{ marginTop: 20, display: "inline-flex", justifyContent: "center" }} spacing={4} alignContent="center">
      <PlanCard
        planTitle={t("plans.plancard_indi_trial_title")}
        desc={t("plans.plancard_indi_trial_desc")}
        content={[
          <Grid container alignItems="center"><FitnessCenter style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_trial_content_1")}</Grid>,
          <Grid container alignItems="center"><SportsEsports style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_trial_content_2")}</Grid>,
          <Grid container alignItems="center"><EventAvailable style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_trial_content_3")}</Grid>
        ]}
        priceText={renderTrialPrice()}
        // route={() => props.history.push("/requestdemo")}
        route={() => navigate("/requestdemo")}
      />

      <PlanCard
        planTitle={t("plans.plancard_indi_full_title")}
        desc={t("plans.plancard_indi_full_desc")}
        content={[
          <Grid container alignItems="center"><PlaylistAddCheck style={{ width: 18, height: 18, color: "#89B98B", marginRight: 10 }} /><span style={{ color: "#89B98B" }}>{t("plans.plancard_indi_full_content_1")}</span></Grid>,
          <Grid container alignItems="center"><ImportExport style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_full_content_2")}</Grid>,
          <Grid container alignItems="center"><Public style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_full_content_3")}</Grid>,
          <Grid container alignItems="center"><Assignment style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_full_content_4")}</Grid>,
          <Grid container alignItems="center"><Create style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_indi_full_content_5")}</Grid>
        ]}
        priceText={renderIndividualPrice()}
        route={() => setIndividualFullVersionPanelOpen(true)}
      />

      <Grid item xs={12}>
        <Button variant="contained" onClick={() => setChosenPlanType("center")} size="large">{t("plans.plancard_indi_swap_plan_butt")}</Button>
      </Grid>
    </Grid>
  );

  const renderCenterPlanCards = () => (
    <Grid container style={{ marginTop: 20, display: "inline-flex", justifyContent: "center" }} spacing={4} alignContent="center">
      <PlanCard
        planTitle={t("plans.plancard_center_trial_title")}
        desc={t("plans.plancard_center_trial_desc")}
        content={[
          <Grid container alignItems="center"><PlaylistAddCheck style={{ width: 18, height: 18, color: "#89B98B", marginRight: 10 }} /><span style={{ color: "#89B98B" }}>{t("plans.plancard_center_trial_content_1")}</span></Grid>,
          <Grid container alignItems="center"><SupervisorAccount style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_trial_content_2")}</Grid>,
          <Grid container alignItems="center"><ImportExport style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_trial_content_3")}</Grid>,
          <Grid container alignItems="center"><Public style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_trial_content_4")}</Grid>
        ]}
        priceText={renderCenterTrialPrice()}
        // route={() => props.history.push("/centerregister")}
        route={() => navigate("/centerregister")}
      />

      <PlanCard
        planTitle={t("plans.plancard_center_full_title")}
        desc={t("plans.plancard_center_full_desc")}
        content={[
          <Grid container alignItems="center"><PlaylistAddCheck style={{ width: 18, height: 18, color: "#89B98B", marginRight: 10 }} /><span style={{ color: "#89B98B" }}>{t("plans.plancard_center_full_content_1")}</span></Grid>,
          <Grid container alignItems="center"><Build style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_full_content_2")}</Grid>,
          <Grid container alignItems="center"><Settings style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_full_content_3")}</Grid>,
          <Grid container alignItems="center"><Assignment style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_full_content_4")}</Grid>,
          <Grid container alignItems="center"><Create style={{ width: 18, height: 18, marginRight: 10 }} />{t("plans.plancard_center_full_content_5")}</Grid>
        ]}
        priceText={renderCenterPrice()}
        route={() => setCenterFullVersionPanelOpen(true)}
      />

      <Grid item xs={12}>
        <Button variant="contained" onClick={() => setChosenPlanType("individual")} size="large">{t("plans.plancard_center_swap_plan_butt")}</Button>
      </Grid>
    </Grid>
  );

  const renderPlanTypes = () => (
    <Grid container style={{ marginTop: 20, display: "inline-flex", justifyContent: "center" }} spacing={4}>
      <PlanType
        planTitle={t("plans.plan_type_indi_title")}
        desc={t("plans.plan_type_indi_desc")}
        image={<PlanIndividual width="100%" height="100%" preserveAspectRatio="xMidYMax meet" />}
        onClickShowPlans={() => setChosenPlanType("individual")}
      />
      <PlanType
        planTitle={t("plans.plan_type_cetner_title")}
        desc={t("plans.plan_type_center_desc")}
        image={<PlanCenter width="100%" height="100%" preserveAspectRatio="xMidYMax meet" />}
        onClickShowPlans={() => setChosenPlanType("center")}
      />
    </Grid>
  );

  const IndividualFullVersionPanel = () => {
    return (
      <Dialog
        open={individualFullVersionPanelOpen}
        fullWidth
        onClose={() => setIndividualFullVersionPanelOpen(false)}
        maxWidth={"sm"}
      >
        <DialogTitle>{t("plans.full_indi_title")}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <Typography>
              {t("plans.full_indi_content")}
            </Typography>
            <br />
            <Typography>
              {t("plans.contact_us_dialog_email")}<a href="mailto: info@medmindtechnology.hk">info@medmindtechnology.hk</a>
            </Typography>
            <Typography>
              {t("plans.contact_us_dialog_phone")}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            variant="contained" 
            disableElevation 
            onClick={() => navigate("/requestdemo")}
            color="primary"
          >
            {t("butt.register")}
        </Button>
        <Button variant="contained" disableElevation onClick={() => setIndividualFullVersionPanelOpen(false)} color="primary">
            {t("butt.close")}
        </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const CenterFullVersionPanel = () => {
    return (
      <Dialog
        open={centerFullVersionPanelOpen}
        fullWidth
        onClose={() => setCenterFullVersionPanelOpen(false)}
        maxWidth={"sm"}
      >
        <DialogTitle>{t("plans.full_center_title")}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <Typography>
              {t("plans.full_center_content")}
            </Typography>
            <br />
            <Typography>
              {t("plans.contact_us_dialog_email")}<a href="mailto: info@medmindtechnology.hk">info@medmindtechnology.hk</a>
            </Typography>
            <Typography>
              {t("plans.contact_us_dialog_phone")}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            variant="contained"
            disableElevation
            // onClick={() => props.history.push("/centerregister")} 
            onClick={() => navigate("/centerregister")}
            color="primary"
          >
            {t("butt.register")}
        </Button>
        <Button variant="contained" disableElevation onClick={() => setCenterFullVersionPanelOpen(false)} color="primary">
            {t("butt.close")}
        </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Container disableGutters maxWidth='xl' style={{ margin: 0, maxWidth: "100%", height: "100vh" }}>
      <div
        style={{ 
          // cursor: "pointer", 
          position: "relative",
          alignContent: "center",
          zIndex: -1,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${top})`,
          backgroundPosition: "left top", 
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "cover", 
          backgroundSize: "100%",
        }} 
      >

      <IndividualFullVersionPanel />
      <CenterFullVersionPanel />

      <Typography style={{ paddingTop: "20%", fontVariant: "bold" }} color="primary" variant="h4">
        {t("plans.register")}
      </Typography>

      <div style={{ margin: "0 auto", marginBottom: 20, fontSize: "26px", width: "80%" }}>{t("plans.desc_1")}</div>

      <Card style={{ transition: "transform .25s", margin: "0 auto", width: "80%", maxWidth: "1000px", borderRadius: 10, boxShadow: "0 8px 20px -12px rgb(0 0 0 / 30%)", backgroundColor: "rgba(240, 240, 240, 0.25)" }}>
        <div style={{ margin: 20 }}>
          <Grid container spacing={3}>
            <PlanType fullWidth image={<Pros1 width="100%" height="100%" preserveAspectRatio="xMidYMax meet" />} planTitle={t("plans.plan_title_1")} desc={t("plans.plan_desc_1")} evaluate={false} />
            <PlanType fullWidth image={<Pros2 width="100%" height="100%" preserveAspectRatio="xMidYMax meet" />} planTitle={t("plans.plan_title_2")} desc={t("plans.plan_desc_2")} evaluate={false} />
            <PlanType fullWidth image={<Pros3 width="100%" height="100%" preserveAspectRatio="xMidYMax meet" />} planTitle={t("plans.plan_title_3")} desc={t("plans.plan_desc_3")} evaluate={false} />
          </Grid>
        </div>
      </Card>

      <Divider style={{ margin: "40px auto", width: "80%", }} />

      <Typography style={{ marginTop: 10 }} color="primary" variant="h4">
        {t("plans.desc_2")}
      </Typography>

      <div style={{ position: "relative", width: "100%", marginTop: 0, paddingBottom: 50 }}>
        <ReactFade in={chosenPlanType === null} timeout={500}>
          {/* <div style={{ position: "relative", width: "100%", top: 0 }}> */}
            {renderPlanTypes()}
          {/* </div> */}
        </ReactFade>

        <ReactFade in={chosenPlanType === "individual"} timeout={500}>
          {/* <div style={{ position: "absolute", width: "100%", top: 0 }}> */}
            {renderIndividualPlanCards()}
          {/* </div> */}
        </ReactFade>

        <ReactFade in={chosenPlanType === "center"} timeout={500}>
          {/* <div style={{ position: "absolute", width: "100%", top: 0 }}> */}
            {renderCenterPlanCards()}
          {/* </div> */}
        </ReactFade>
      </div>

      </div>
      {props.langButt}
      <Button
        onClick={() => navigate("/")}
        color="primary"
        variant="contained"
        sx={{ display: "block", position: "fixed", bottom: 70, right: 20 }}
        size="small"
      >
        <ReplyIcon fontSize="large"/>
      </Button>
    </Container>
  )
}